<!--component html goes here -->
<div
  #dialog
  aria-labelledby="modalTitle"
  class="country-list-modal"
  tabindex="0"
>
  <span class="sr-only" id="modalTitle">
    {{ airportLookupContent?.fullAirportList }}
  </span>
  <div class="bg-dark action-bar d-block d-lg-none">
    <button
      (click)="back()"
      [ngClass]="{
        'd-sm-block':
          isselectedCountry === true || isselectedProviences === true
      }"
      class="d-sm-none float-left back d-none d-md-none"
      type="button"
    >
      Back
    </button>
    <button (click)="close()" class="float-right close" type="button">
      Close
    </button>
  </div>
  <div
    [ngClass]="{
      'd-sm-none': isselectedProviences === true || isselectedCountry === true
    }"
    class="country-list-container d-md-block"
  >
    <div class="country-list-header pl-0">
      <h3>{{ airportLookupContent?.lookupLabel }}</h3>
      <button
        (click)="close()"
        class="full-list-close float-right circle-outline icon-moreoptionsclose"
        type="button"
      >
        <img
          alt="close"
          class="ng-tns-c0-0"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        />
      </button>
    </div>
    <div class="country-list-body pl-0 pr-0">
      <tabset role="tablist">
        <tab
          (selectTab)="tabSelected('country', $event)"
          [heading]="airportLookupContent?.countryLabel"
          aria-controls="country-panel"
          id="country-tab"
        >
          <div
            aria-labelledby="country-tab"
            class="tab-Container row ml-1"
            id="country-panel"
            role="tabpanel"
          >
            <div
              [ngClass]="{ 'd-none': countryList.length === 0 }"
              class="country-left-container pl-0 col-md-6 col-lg-6"
            >
              <span class="country-lable">
                {{ airportLookupContent?.countries }}
              </span>
              <ul class="list-container pl-0" tabindex="-1">
                <li
                  (click)="select(country, 'country')"
                  *ngFor="let country of countryList"
                  [ngClass]="{ active: selectedCountry === country }"
                  class="country-list"
                >
                  <a href="javascript:void(0);">{{ country.countryName }}</a>
                </li>
              </ul>
            </div>
            <div
              [ngClass]="{ 'd-none': selectedCountry === null }"
              class="airport-right-container col-md-6 col-lg-6"
            >
              <span class="country-lable d-md-block">
                {{ selectedCountryName }}
                {{ airportLookupContent?.airportsLabel }}
              </span>
              <ul
                [ngClass]="{ 'd-none': airportListCountryWise.length === 0 }"
                class="list-container pl-0"
              >
                <li
                  *ngFor="let airport of airportListCountryWise"
                  class="country-list airport-list"
                >
                  <a
                    (click)="selectedAirport(airport)"
                    href="javascript:void(0);"
                  >
                    {{ airport.cityName
                    }}{{ airport.region ? ', ' + airport.region : '' }} ({{
                      airport.airportCode
                    }})
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </tab>
        <tab
          (selectTab)="tabSelected('proviences', $event)"
          [heading]="airportLookupContent?.usAndCanada"
          active="true"
          aria-controls="us-country-panel"
          aria-selected="true"
          id="us-country-tab"
        >
          <div
            aria-labelledby="us-country-tab"
            class="tab-Container row ml-1"
            id="us-country-panel"
            role="tabpanel"
          >
            <div
              [ngClass]="{ 'd-none': defaultProvincesList.length === 0 }"
              class="country-left-container pl-0 col-md-6 col-lg-6"
            >
              <span class="country-lable">
                {{ airportLookupContent?.usCanadaProvince }}
              </span>
              <ul class="list-container pl-0" tabindex="-1">
                <li
                  (click)="select(country, 'proviences')"
                  *ngFor="let country of defaultProvincesList"
                  [ngClass]="{ active: selectedProviences === country }"
                  class="country-list"
                >
                  <a href="javascript:void(0);">
                    {{ country.stateProvinceName }}
                  </a>
                </li>
              </ul>
            </div>
            <div
              [ngClass]="{ 'd-none': selectedProviences === null }"
              class="airport-right-container col-md-6 col-lg-6"
            >
              <span class="country-lable d-md-block">
                {{ selectedCountryName }}
                {{ airportLookupContent?.airportsLabel }}
              </span>
              <ul
                [ngClass]="{ 'd-none': airportListProviencesWise.length === 0 }"
                class="list-container pl-0"
              >
                <li
                  *ngFor="let airport of airportListProviencesWise"
                  class="country-list airport-list"
                >
                  <a
                    (click)="selectedAirport(airport)"
                    href="javascript:void(0);"
                  >
                    {{ airport.cityName
                    }}{{ airport.region ? ', ' + airport.region : '' }} ({{
                      airport.airportCode
                    }})
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </tab>
        <tab
          (selectTab)="tabSelected('alphabetically', $event)"
          [heading]="airportLookupContent?.alphabeticallyLabel"
          aria-controls="alphabetical-country-panel"
          id="alphabetical-tab"
        >
          <div
            aria-labelledby="alphabetical-tab"
            class="tab-Container row ml-1"
            id="alphabetical-country-panel"
            role="tabpanel"
          >
            <div
              [ngClass]="{
                'd-none': airportListalphAbeticallyWise.length === 0
              }"
              class="country-left-container pl-0 col-md-6 col-lg-6"
            >
              <span class="country-lable">
                {{ airportLookupContent?.airportsLabel }}
              </span>
              <ul class="list-container pl-0" tabindex="-1">
                <li
                  *ngFor="
                    let airport of airportListalphAbeticallyWise
                      | sort : sortOrder
                  "
                  class="country-list airport-list alphabeticaly"
                >
                  <a
                    (click)="selectedAirport(airport)"
                    href="javascript:void(0);"
                  >
                    {{ airport.cityName
                    }}{{ airport.region ? ', ' + airport.region : '' }} ({{
                      airport.airportCode
                    }})
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
  <div
    [ngClass]="{
      'd-sm-none': isselectedCountry === false,
      'd-sm-block': isselectedCountry === true
    }"
    class="tab-Container sm-airports-Conatiner d-none d-md-none row ml-1"
    id="proviences-country-panel
      "
    role="tabpanel "
  >
    <div
      [ngClass]="{ 'd-none': airportListCountryWise.length === 0 }"
      class="country-left-container pl-0 col-md-6 col-lg-6"
    >
      <span class="country-lable">{{ selectedCountryName }} Airports</span>
      <ul class="list-container pl-0">
        <li *ngFor="let airport of airportListCountryWise" class="country-list">
          <a (click)="selectedAirport(airport)" href="javascript:void(0);">
            {{ airport.cityName
            }}{{ airport.region ? ', ' + airport.region : '' }} ({{
              airport.airportCode
            }})
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div
    [ngClass]="{
      'd-sm-none': isselectedProviences === false,
      'd-sm-block': isselectedProviences === true
    }"
    class="tab-Container sm-airports-Conatiner d-none d-md-none row ml-1"
    id="proviences-country-panel
      "
    role="tabpanel "
  >
    <div
      [ngClass]="{ 'd-none': airportListProviencesWise.length === 0 }"
      class="country-left-container pl-0 col-md-6 col-lg-6"
    >
      <span class="country-lable">{{ selectedCountryName }} Airports</span>
      <ul class="list-container pl-0">
        <li
          *ngFor="let airport of airportListProviencesWise"
          class="country-list"
        >
          <a (click)="selectedAirport(airport)" href="javascript:void(0);">
            {{ airport.cityName
            }}{{ airport.region ? ', ' + airport.region : '' }} ({{
              airport.airportCode
            }})
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div
    [ngClass]="{
      'd-sm-none': selectedAlphabetically === null,
      'd-sm-block': selectedAlphabetically !== null
    }"
    aria-labelledby="alphabetical-tab"
    class="tab-Container sm-airports-Conatiner d-none d-md-none row ml-1"
    id="alphabetical-country-panel"
    role="tabpanel"
  >
    <div
      [ngClass]="{ 'd-none': airportListProviencesWise.length === 0 }"
      class="country-left-container pl-0 col-md-6 col-lg-6"
    >
      <span class="country-lable">{{ selectedAlphabetically }} Airports</span>
      <ul class="list-container pl-0">
        <li
          *ngFor="let country of countryList"
          [ngClass]="{ active: airportSelected === country.countryName }"
          class="country-list"
        >
          <a
            (click)="selectedAirport(country.countryName)"
            href="javascript:void(0);"
          >
            {{ country.countryName }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
